module.exports = __webpack_public_path__ + "img/magazine.7406500.webp";